import React from 'react';
import { Box } from '@mui/material';
import { InfoTooltip } from '@components/common/InfoTooltip';
import { dayTaskProgress } from '@/styles/tokens';
import { DayTaskCompletion } from './dayTaskCompletion';

interface DayTaskCompletionBadgeProps {
  /** `null` - немає даних (без призначень на день або жодне ще не настало): «Виконано –» і порожня смуга. */
  completion: DayTaskCompletion | null;
  /** Вузька колонка (подання "2 тижні") - без слова «Виконано». */
  compact?: boolean;
}

/** Виконання призначень дня під датою в заголовку колонки календаря: підпис і смуга прогресу. */
export const DayTaskCompletionBadge: React.FC<DayTaskCompletionBadgeProps> = ({ completion, compact = false }) => {
  const value = completion ? `${completion.percent}%` : '–';
  return (
    <InfoTooltip
      title={completion ? 'Виконання' : 'Немає даних'}
      description={completion
        ? `Клієнт виконав ${completion.completed} з ${completion.total} призначених задач.`
        : 'Клієнт не відзначив виконані задачі.'}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px', mt: 0.5 }}>
        <Box
          component="span"
          sx={{ fontSize: 12, lineHeight: '14px', fontWeight: 400, color: 'text.secondary', whiteSpace: 'nowrap' }}
        >
          {compact ? value : `Виконано ${value}`}
        </Box>
        <Box
          sx={theme => ({
            alignSelf: 'stretch',
            height: 4,
            borderRadius: '2px',
            overflow: 'hidden',
            bgcolor: dayTaskProgress.track[theme.palette.mode === 'dark' ? 'dark' : 'light'],
          })}
        >
          <Box sx={{ width: `${completion?.percent ?? 0}%`, height: '100%', borderRadius: '2px', bgcolor: dayTaskProgress.fill }} />
        </Box>
      </Box>
    </InfoTooltip>
  );
};
